import { Skeleton } from "antd";
import { StyledAppsContainerSidebar } from "./index.styled";

export type AppsContainerSidebarProps = {
  loading?: boolean;
  children: React.ReactNode;
  minWidth?: string;
  maxWidth?: string;
};

export default function AppsContainerSidebar(props: AppsContainerSidebarProps) {
  const {
    children,
    loading,
    // minWidth = "50px",
    // maxWidth = "300px",
  } = props;
  // const { collapsed } = useSidebar();

  if (loading) return <Skeleton active />;

  return <StyledAppsContainerSidebar>{children}</StyledAppsContainerSidebar>;
}
